export const BON_STOCK = {
  lecture: { module: 'stock', element: 'bon_stock', rule: 'lecture' },
  maj: { module: 'stock', element: 'bon_stock', rule: 'maj' },
  exporter: { module: 'stock', element: 'bon_stock', rule: 'exporter' },
  supprimer: { module: 'stock', element: 'bon_stock', rule: 'supprimer' },
};

export default BON_STOCK;
